/* LiberNovo × ergoliv co-brand PDP controller.
   State (model / color / depth / bundle / qty / gallery index) drives the buy box,
   gallery, sticky bar and video modals. Prices/availability come straight from
   the Shopify variants printed into the [data-lnx-data] JSON island, so the
   page never invents a number — it only ever shows a real variant's price.

   O pagina pe model (docs/seo/plan-pagini-pe-model.md, C3/C3b/C4):
   - pornirea se face de la D.selected (varianta randata pe server), nu de la un model fix;
   - "o"[0] e modelul fara adancime, "d" e adancimea; varianta se alege si dupa adancime,
     altfel 45 cm punea in cos scaunul de 48;
   - o varianta DENY cu stoc 0 e „Indisponibil", cu butoanele de cos dezactivate;
   - orice schimbare pe pagina scrie ?variant= cu replaceState, pastrand starea istoricului
     ({lnx:1} pus de lnx-familie.js), iar titlul tab-ului primeste culoarea;
   - window.LNX = { boot, destroy }: lnx-familie.js opreste radacina veche si o porneste pe
     cea noua dupa o schimbare de model fara reincarcare. Toate listener-ele trec printr-un
     AbortController, deci 10 schimbari nu lasa 10 listener-e pe window. */
(function () {
  function init(root) {
    if (!root || root.__lnxInit) return;

    var dataEl = root.querySelector('[data-lnx-data]');
    if (!dataEl) return;
    var D;
    try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
    root.__lnxInit = true;

    // ---- ciclul de viata: tot ce se agata de window/document/elemente se scoate la destroy ----
    var ac = (typeof AbortController === 'function') ? new AbortController() : null;
    function on(el, type, fn, opts) {
      if (!el) return;
      var o = {};
      if (opts) for (var k in opts) o[k] = opts[k];
      if (ac) o.signal = ac.signal;
      el.addEventListener(type, fn, o);
    }
    var timers = [];
    var vio = null, rMQ = null, rApplyModeRef = null, rSyncRef = null, rRafRef = { id: 0 };
    function destroy() {
      if (ac) ac.abort();
      timers.forEach(function (t) { clearTimeout(t); });
      timers = [];
      if (vio) { try { vio.disconnect(); } catch (e) {} }
      if (rMQ && rApplyModeRef && rMQ.removeEventListener) { try { rMQ.removeEventListener('change', rApplyModeRef); } catch (e) {} }
      if (rRafRef.id) cancelAnimationFrame(rRafRef.id);
      root.__lnxInit = false;
      root.__lnxDestroy = null;
    }
    root.__lnxDestroy = destroy;

    var $ = function (s, c) { return (c || root).querySelector(s); };
    var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
    var VARS = D.variants || [];

    var state = {
      model: D.modelOrder[D.modelOrder.length - 1], // default = top model
      color: (D.colors && D.colors[0]) || 'Graphit',
      bundle: 'Bază',
      depth: '48 cm',
      qty: 1,
      idx: 0
    };

    // D.cur is a Shopify-formatted sample ("1.000 lei" / "1.000 Ft"); strip the digits to get the
    // active presentment currency symbol so prices match the market (lei on .ro, Ft on .hu).
    var CUR = (((D && D.cur) || '0 lei').replace(/[0-9.,\s  ]/g, '')) || 'lei';
    // The island now carries exact prices (4257.25, not 4257). money() floors rather than rounds
    // so every existing surface keeps showing precisely what it showed before; only the headline
    // price opts into the cents, via moneyBig().
    // Gruparea cifrelor urmeaza limba magazinului — romana scrie 334.900, maghiara 334 900.
    var LOC = (D && D.locale) || 'ro-RO';
    // Textele vin din sectiune, care le citeste din fisierele de limba. Literalele romanesti
    // raman ca fallback: o suprafata fara insula i18n merge exact ca inainte.
    var T = (D && D.i18n) || {};
    function t(k, fb) { return T[k] || fb; }
    function money(n) {
      return Math.floor(Number(n)).toLocaleString(LOC, { maximumFractionDigits: 0 }) + ' ' + CUR;
    }
    // Headline price: whole lei at full size, bani smaller — the model cards below it already
    // showed 4.257,25 while the big number said 4.257, which read like two different prices.
    // Returns HTML, so the caller must use innerHTML.
    function moneyBig(n) {
      var v = Number(n), whole = Math.floor(v), bani = Math.round((v - whole) * 100);
      var head = whole.toLocaleString(LOC, { maximumFractionDigits: 0 });
      var dec = bani > 0 ? '<span class="lnx-price__dec">,' + String(bani).padStart(2, '0') + '</span>' : '';
      return head + dec + ' ' + CUR;
    }
    // Pretul taiat si „Economisești" se scriu exact, cu bani daca exista (4.257,25), ca in
    // Liquid. money() taie banii, iar la un pret de referinta asta ar insemna alta cifra.
    function moneyExact(n) {
      var c = Math.round(Number(n) * 100);
      return (c / 100).toLocaleString(LOC, { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 }) + ' ' + CUR;
    }
    // Ascunde si cu `hidden`, nu doar cu display: scriptul de cut-off din theme.liquid
    // pune `hidden` pe [data-camp-until] expirate, iar noi trebuie sa-l putem si scoate.
    function showEl(el, on) {
      el.style.display = on ? '' : 'none';
      if (on) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    }
    // Clic simplu cu stanga: doar atunci preluam un link. Cmd/Ctrl/Shift/Alt sau clicul din
    // mijloc deschid linkul cum ar face-o browserul (tab nou etc.).
    function plainClick(e) { return !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) && (e.button === undefined || e.button === 0); }

    function glacierOK(model) { return (D.glacierModels || []).indexOf(model) !== -1; }
    // Adancimea: o varianta fara "d" se potriveste cu orice adancime (Maxis, sau Omni pe calea veche).
    function matchD(v) { return !v.d || v.d === state.depth; }
    // Din mai multe potriviri, intai cea cu exact adancimea curenta. Conteaza cand acelasi model
    // are si variante fara sufix si variante „… 45 cm" (la 1.3, la o revenire sau pe o pagina
    // din cache): altfel varianta fara sufix (48 cm) ar castiga si la 45 cm.
    function exactD(list) { for (var i = 0; i < list.length; i++) { if (list[i].d && list[i].d === state.depth) return list[i]; } return list[0]; }
    // perModelColors (Omni): each model only offers the colours that actually have a variant.
    function colorAvail(model, color) { return VARS.some(function (v) { return v.o[0] === model && v.o[1] === color; }); }
    function firstColorForModel(model) { var cs = D.colors || []; for (var i = 0; i < cs.length; i++) { if (colorAvail(model, cs[i])) return cs[i]; } return cs[0]; }
    // La schimbarea modelului pe aceeasi pagina (Omni <-> Omni Gen) culorile nu se suprapun:
    // prima culoare cu o Baza disponibila la adancimea curenta, altfel prima care exista.
    function pickColor(model) {
      var cs = D.colors || [];
      for (var i = 0; i < cs.length; i++) {
        var c = cs[i];
        if (VARS.some(function (v) { return v.o[0] === model && v.o[1] === c && v.o[2] === ((D.bundles && D.bundles[0]) || 'Bază') && matchD(v) && v.avail; })) return c;
      }
      return firstColorForModel(model);
    }
    function fixColor() { if (D.perModelColors && !colorAvail(state.model, state.color)) state.color = pickColor(state.model); }
    function hasBundles() { return (D.bundles || []).length > 1; }
    // Adancimi reale = modelul are variante cu "d". Selectorul apare doar cand le are pe amandoua.
    function depthsOf(model) {
      var out = {};
      VARS.forEach(function (v) { if (v.o[0] === model && v.d) out[v.d] = true; });
      return out;
    }
    function realDepth(model) { var ds = depthsOf(model); return !!(ds['45 cm'] && ds['48 cm']); }
    function hasDepthVariants(model) { var ds = depthsOf(model); for (var k in ds) return true; return false; }
    // Calea veche (rezerva, C1): fara variante de adancime, dar cu o cheie Model|Culoare in stoc_45.
    function legacyDepth() {
      return !hasDepthVariants(state.model) && !!D.depth45 && D.depth45[state.model + '|' + state.color] !== undefined;
    }
    // Daca adancimea curenta nu exista la combinatia aleasa, trecem pe 48 cm (sau pe cea care exista).
    function fixDepth() {
      if (!hasDepthVariants(state.model)) return;
      var ok = VARS.some(function (v) { return v.o[0] === state.model && v.o[1] === state.color && v.d === state.depth; });
      if (ok) return;
      var has48 = VARS.some(function (v) { return v.o[0] === state.model && v.o[1] === state.color && v.d === '48 cm'; });
      if (has48) { state.depth = '48 cm'; return; }
      var any = VARS.filter(function (v) { return v.o[0] === state.model && v.o[1] === state.color && v.d; })[0];
      if (any) state.depth = any.d;
    }
    function bundleAvail(b) { return VARS.some(function (v) { return v.o[0] === state.model && v.o[1] === state.color && v.o[2] === b && matchD(v) && v.avail; }); }
    function bundleExists(b) { return VARS.some(function (v) { return v.o[0] === state.model && v.o[1] === state.color && v.o[2] === b && matchD(v); }); }
    function firstBundle(model) { var bs = D.bundles || []; for (var i = 0; i < bs.length; i++) { if (VARS.some(function (v) { return v.o[0] === model && v.o[1] === state.color && v.o[2] === bs[i] && matchD(v) && v.avail; })) return bs[i]; } return bs[0] || 'Bază'; }
    // Real availability. `q` (variant.inventory_quantity) is emitted per-variant when the section is stock-aware.
    // For a bundle the chair component is CONTINUE (so Shopify drops it from the derivation) — re-gate on the
    // matching base ("Bază") variant's own stock: real = min(bundle derived qty, base chair qty).
    // Baza se cauta la ACEEASI adancime: un pachet de 45 cm nu se verifica cu stocul scaunului de 48.
    function vq(x) { return (x && typeof x.q === 'number') ? x.q : Infinity; }
    function baseVariant(v) { var bn = (D.bundles && D.bundles[0]) || 'Bază'; return VARS.filter(function (x) { return x.o[0] === v.o[0] && x.o[1] === v.o[1] && x.o[2] === bn && (x.d || '') === (v.d || ''); })[0]; }
    function realQty(v) { if (!v) return 0; var own = vq(v); if (hasBundles() && v.o[2] && D.bundles && v.o[2] !== D.bundles[0]) return Math.min(own, vq(baseVariant(v))); return own; }
    function stockPre(v) { return (v && typeof v.q === 'number') ? (realQty(v) <= 0) : false; }
    function gallery() {
      var fb = (D.colors && D.colors[0]) || state.color;
      return D.galleries[state.model + '|' + state.color] || D.galleries[state.model + '|' + fb] || [];
    }
    function variant() {
      return exactD(VARS.filter(function (v) {
        return v.o[0] === state.model && v.o[1] === state.color && (!hasBundles() || v.o[2] === state.bundle) && matchD(v);
      }));
    }
    // Varianta din spatele unui buton de adancime: acelasi model, culoare si pachet, altfel Baza.
    function depthVariant(dv) {
      var bn = (D.bundles && D.bundles[0]) || 'Bază';
      var pick = function (b) { return VARS.filter(function (v) { return v.o[0] === state.model && v.o[1] === state.color && (!hasBundles() || v.o[2] === b) && v.d === dv; })[0]; };
      return pick(state.bundle) || pick(bn);
    }
    // Pretul Bazei modelului: la culoarea si adancimea curente, altfel prima Baza a modelului.
    function modelBase(model) {
      var bn = 'Bază';
      var same = exactD(VARS.filter(function (x) { return x.o[0] === model && x.o[1] === state.color && (!hasBundles() || x.o[2] === bn) && matchD(x); }));
      var v = same || VARS.filter(function (x) { return x.o[0] === model && (!hasBundles() || x.o[2] === bn); })[0];
      return v ? v.price : 0;
    }
    // Pachetul la modelul, culoarea si adancimea curente, si diferenta lui fata de Baza (null = nu exista).
    // Din 30 oct 2026 diferenta poate fi NEGATIVA: LiberNovo a pus pachetele sub scaunul singur, iar noi
    // le-am urmat. Atunci nu scriem „+-804 lei", ci „804 lei mai puțin" si semnalam pachetul.
    function bundleVar(b) { return exactD(VARS.filter(function (x) { return x.o[0] === state.model && x.o[1] === state.color && x.o[2] === b && matchD(x); })); }
    function bundleDelta(b) { var bv = bundleVar(b), bb = modelBase(state.model); return (bv && bb) ? bv.price - bb : null; }

    // ---- ?variant= si titlul tab-ului (C3, C3b) ----
    // Orice alegere de pe pagina duce la o singura varianta: ?variant=<id> cu replaceState,
    // fara fetch. Starea istoricului se pastreaza ({lnx:1} pus de lnx-familie.js), altfel
    // butonul Inapoi n-ar mai sti sa refaca pagina de model.
    function setTitle(v) {
      if (!v || !D.title || !D.title.base) return;
      document.title = D.title.base + ' – ' + v.o[1] + (D.title.shop ? ' – ' + D.title.shop : '');
    }
    function syncUrl() {
      var v = variant();
      if (!v) return;
      try {
        if (window.history && history.replaceState && window.URL) {
          var u = new URL(location.href);
          u.searchParams.set('variant', v.id);
          var st = {};
          if (history.state && typeof history.state === 'object') { for (var k in history.state) st[k] = history.state[k]; }
          history.replaceState(st, '', u.pathname + u.search + u.hash);
        }
      } catch (e) {}
      setTitle(v);
      analyticsCtx();
    }
    // Campurile din ergoliv-analytics.liquid urmeaza varianta aleasa (model, adancime).
    function analyticsCtx() {
      try {
        var A = window.ErgolivAnalytics;
        if (!A || !A.product) return;
        var v = variant();
        A.product.model = state.model;
        A.product.adancime = (v && v.d) || (legacyDepth() ? state.depth : '');
        if (v) A.product.variant = v.id;
      } catch (e) {}
    }

    // ---- gallery rendering ----
    function paintGallery() {
      var g = gallery();
      if (state.idx > g.length - 1) state.idx = 0;
      var main = $('[data-lnx-main-img]');
      if (main && g[state.idx]) { main.src = g[state.idx]; main.alt = 'LiberNovo ' + state.model + ' ' + state.color; }
      var counter = $('[data-lnx-counter]');
      if (counter) counter.textContent = (state.idx + 1) + ' / ' + g.length;
      // Mentiuni legate de o combinatie model|culoare (ex. pozele Electric folosite la Airflow Glacier).
      $$('[data-lnx-for-mc]').forEach(function (el) {
        var ok = el.getAttribute('data-lnx-for-mc') === state.model + '|' + state.color;
        el.hidden = !ok;
        el.style.display = ok ? '' : 'none';
      });

      var thumbs = $('[data-lnx-thumbs]');
      if (thumbs) {
        thumbs.innerHTML = '';
        g.forEach(function (url, i) {
          var b = document.createElement('button');
          b.className = 'lnx-thumb';
          b.type = 'button';
          b.setAttribute('aria-current', i === state.idx ? 'true' : 'false');
          b.setAttribute('aria-label', t('imageN', 'Imaginea') + ' ' + (i + 1));
          var im = document.createElement('img');
          im.src = url; im.alt = ''; im.loading = 'lazy';
          b.appendChild(im);
          b.addEventListener('click', function () { state.idx = i; paintGallery(); });
          thumbs.appendChild(b);
        });
      }
      // sticky + lightbox thumbnails
      var sImg = $('[data-lnx-sticky-img]');
      if (sImg && g[0]) sImg.src = g[0];
      var lbMain = $('[data-lnx-lb-img]');
      if (lbMain && g[state.idx]) lbMain.src = g[state.idx];
    }

    function step(dir) {
      var g = gallery();
      if (!g.length) return;
      state.idx = (state.idx + dir + g.length) % g.length;
      paintGallery();
    }

    // ---- buy box rendering ----
    function paint() {
      var v = variant();
      // DENY + 0 (Shopify available = false) = indisponibil: nu „Precomandă acum" cu butonul
      // activ, care ar da 422 la adaugare. Si nu suprascriem starea randata pe server.
      var unavail = !!v && !v.avail;
      var preBundleSel = !!(D.preBundle && state.bundle === D.preBundle);
      var pre = !unavail && (!!D.preorder || preBundleSel || stockPre(v));
      var price = v ? v.price : modelBase(state.model);
      var cmp = v ? v.cmp : 0;
      // Campania: pretul taiat, procentul, „Economisești", eticheta si nota apar DOAR cat
      // promo-gate e `on` (D.camp.on, pus de Liquid), varianta are compare_at peste pret si
      // fereastra n-a expirat intre timp (HTML din cache, tab lasat deschis). Altfel se ascund
      // si se golesc, ca sa nu ramana nicio cifra de referinta in pagina.
      var campOK = !!(D.camp && D.camp.on) && cmp > price && (!D.camp.end || Date.now() / 1000 < D.camp.end);
      // Calculat in bani, ca in Liquid (impartire intreaga): procentul se rotunjeste IN JOS,
      // altfel pagina scria -8% din server si -9% dupa JS.
      var cmpC = campOK ? Math.round(cmp * 100) : 0, priceC = Math.round(price * 100);
      var save = campOK ? (cmpC - priceC) / 100 : 0;
      var disc = campOK ? Math.floor((cmpC - priceC) * 100 / cmpC) : 0;

      var bigEl = $('[data-lnx-price]');
      if (bigEl) bigEl.innerHTML = moneyBig(price * state.qty);
      var oldEl = $('[data-lnx-old]');
      if (oldEl) { oldEl.textContent = campOK ? moneyExact(cmp * state.qty) : ''; showEl(oldEl, campOK); }
      var saveEl = $('[data-lnx-save]');
      if (saveEl) {
        var saveAmt = moneyExact(save * state.qty);
        var saveTpl = (D.camp && D.camp.save_tpl && D.camp.save_tpl.indexOf('{suma}') !== -1) ? D.camp.save_tpl : '';
        saveEl.textContent = (campOK && save > 0) ? (saveTpl ? saveTpl.replace('{suma}', saveAmt) : t('save', 'Economisești') + ' ' + saveAmt) : '';
        showEl(saveEl, campOK && save > 0);
      }
      // Procentul: badge-ul de pe galerie si pastila de langa pret. Sub 1% nu se arata.
      var discOK = campOK && disc >= 1;
      $$('[data-lnx-disc], [data-lnx-camp-pct]').forEach(function (el) { el.textContent = discOK ? '−' + disc + '%' : ''; showEl(el, discOK); });
      var chipEl = $('[data-lnx-camp-chip]');
      if (chipEl) { chipEl.textContent = campOK ? [D.camp.name, D.camp.period].filter(Boolean).join(' · ') : ''; showEl(chipEl, campOK); }
      var cNote = $('[data-lnx-camp-note]');
      if (cNote) {
        var cnUntil = cNote.querySelector('[data-lnx-camp-until]'), cnRef = cNote.querySelector('[data-lnx-camp-ref]');
        if (cnUntil) cnUntil.textContent = campOK ? (D.camp.until || '') : '';
        if (cnRef) cnRef.textContent = campOK ? (D.camp.note || '') : '';
        showEl(cNote, campOK);
      }

      // Pretul recomandat de producator (MAP). Se afiseaza ETICHETAT, niciodata taiat
      // si fara procent: regula celor 30 de zile priveste pretul ANTERIOR propriu, iar
      // pretul recomandat e alt obiect juridic doar cat timp nu e prezentat ca reducere.
      // Doar pe RON: valoarea din metafield e in lei, nu se converteste pe alte piete.
      var prp = (v && v.prp) ? v.prp : 0;
      var prpEl = $('[data-lnx-prp]');
      if (prpEl) {
        var showPrp = (D.prpOn !== false) && prp > price;
        // Scriem intr-un copil, nu in prpEl: altfel am sterge butonul de info si tooltipul.
        var prpTxt = $('[data-lnx-prp-txt]');
        if (prpTxt) prpTxt.innerHTML = showPrp ? ((D.prpLabel || 'PRP') + ': <b>' + money(prp * state.qty) + '</b>') : '';
        prpEl.style.display = showPrp ? '' : 'none';
      }

      // qty
      setText('[data-lnx-qty]', state.qty);

      // CTA
      var cta = $('[data-lnx-cta]');
      if (cta) {
        cta.classList.toggle('lnx-cta--na', unavail);
        cta.classList.toggle('lnx-cta--pre', pre);
        cta.classList.toggle('lnx-cta--in', !pre && !unavail);
        setText('[data-lnx-cta-label]', unavail ? t('unavailable', 'Indisponibil') : ((pre ? t('preorderNow', 'Precomandă acum') : t('addToCart', 'Adaugă în coș')) + ' · ' + moneyExact(price * state.qty)));
      }
      var preNote = $('[data-lnx-prenote]');
      if (preNote) preNote.style.display = pre ? '' : 'none';

      // stock pill
      var stock = $('[data-lnx-stock]');
      if (stock) {
        stock.classList.toggle('lnx-stock--na', unavail);
        stock.classList.toggle('lnx-stock--pre', pre);
        stock.classList.toggle('lnx-stock--in', !pre && !unavail);
        // Fără dată configurată spunem doar „Precomandă". Un fallback scris în cod se
        // învechește tăcut, și exact așa a ajuns pagina să promită „livrare 12 august".
        var preLabel = t('preorderShip', 'Precomandă · livrare');
        setText('[data-lnx-stock-label]', unavail ? t('unavailable', 'Indisponibil') : (pre ? (D.preorderDate ? preLabel + ' ' + D.preorderDate : t('preorderShort', 'Precomandă')) : t('inStock', 'În stoc · expediere 24–48h')));
      }

      // Greutatea coletului. Markup-ul ajunsese pe live, functia asta nu — de aia
      // elementul se randa gol. Ramane ascuns daca varianta n-are greutate setata.
      var parcel = $('[data-lnx-parcel]');
      if (parcel) {
        var grams = (v && v.w) ? v.w : 0;
        if (grams > 0) {
          var kg = (grams / 1000).toLocaleString(LOC, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
          setText('[data-lnx-parcel-label]',
            t('parcel', 'Colet') + ' ' + kg + ' kg ' + t('parcelTwoPeople', '· recomandăm două persoane la manevrare'));
          parcel.style.display = 'flex';
        } else {
          parcel.style.display = 'none';
        }
      }

      // hidden variant id for the cart form
      var idIn = $('[data-lnx-variant-id]');
      if (idIn && v) idIn.value = v.id;
      var qtyIn = $('[data-lnx-qty-input]');
      if (qtyIn) qtyIn.value = state.qty;
      var cartBtns = $$('[data-lnx-cart-submit]');
      cartBtns.forEach(function (b) {
        b.disabled = !v || unavail;
        if (b.classList.contains('lnx-sticky__cta')) {
          b.classList.toggle('lnx-cta--na', unavail);
          b.classList.toggle('lnx-cta--pre', pre);
          b.classList.toggle('lnx-cta--in', !pre && !unavail);
        }
      });

      // model rows pressed + price (linkurile poarta aria-current, butoanele aria-pressed)
      $$('[data-lnx-model]').forEach(function (btn) {
        var m = btn.getAttribute('data-lnx-model');
        btn.setAttribute(btn.tagName === 'A' ? 'aria-current' : 'aria-pressed', m === state.model ? 'true' : 'false');
      });
      // color buttons — only the (optional) gated color is restricted to glacierModels; all others always available
      $$('[data-lnx-color]').forEach(function (btn) {
        var c = btn.getAttribute('data-lnx-color');
        if (D.perModelColors) {
          var av = colorAvail(state.model, c);
          btn.style.display = av ? '' : 'none';
          btn.disabled = !av;
        } else {
          btn.disabled = !((c !== D.gatedColor) || glacierOK(state.model));
        }
        btn.setAttribute('aria-pressed', c === state.color ? 'true' : 'false');
      });
      var note = $('[data-lnx-color-note]');
      if (note) note.style.display = (!D.perModelColors && D.gatedColor && !glacierOK(state.model)) ? '' : 'none';
      setText('[data-lnx-color-label]', state.color);

      // Adancimea sezutului (C3b).
      // Variante reale: selectorul apare doar cand modelul are ambele adancimi; fiecare buton
      // arata varianta lui — dezactivat pe DENY + 0 („momentan indisponibil"), „precomandă"
      // pe CONTINUE + 0. In cos nu mai pleaca nicio proprietate: adancimea e in varianta.
      // Calea veche (rezerva, C1): fara variante de adancime, cu o cheie in stoc_45 — proprietate
      // de linie si poarta pe numarul tinut de mana, exact ca inainte.
      var depthOpt = $('[data-lnx-depth-opt]');
      if (depthOpt) {
        var real = realDepth(state.model);
        var legacy = !real && legacyDepth();
        depthOpt.style.display = (real || legacy) ? '' : 'none';
        var depthIn = $('[data-lnx-depth-input]');
        if (real) {
          $$('[data-lnx-depth]').forEach(function (b) {
            var dv = b.getAttribute('data-lnx-depth');
            var x = depthVariant(dv);
            var na = !x || !x.avail;
            var xp = !na && (!!D.preorder || stockPre(x));
            b.disabled = na;
            b.setAttribute('data-soldout', na ? 'true' : 'false');
            b.textContent = dv + (na ? ' · ' + t('depthUnavailable', 'momentan indisponibil') : (xp ? ' · ' + t('depthPreorder', 'precomandă') : ''));
            b.setAttribute('aria-pressed', dv === state.depth ? 'true' : 'false');
          });
        } else if (legacy) {
          // Cheia e „Model|Culoare": Omni SE are o singură culoare, dar Omni Gen se vinde în
          // două, iar 45 cm poate fi pe stoc la una și zero la cealaltă. Prezența cheii spune că
          // acea combinație chiar se face în ambele adâncimi.
          var d45 = D.depth45[state.model + '|' + state.color];
          // Pe precomandă numărul de 45 cm nu blochează nimic: nu iei de pe raft, comanzi.
          // Garda a fost gândită pentru SE, unde 45 cm erau puține și pe stoc — aplicată la un
          // model care încă n-a sosit, scria „45 cm · epuizat" la ceva ce nici nu s-a produs.
          var s45 = pre ? Infinity : ((typeof d45 === 'number') ? d45 : Infinity);
          if (s45 <= 0 && state.depth === '45 cm') state.depth = '48 cm';
          $$('[data-lnx-depth]').forEach(function (b) {
            var dv = b.getAttribute('data-lnx-depth');
            var soldOut = (dv === '45 cm') && (s45 <= 0);
            b.disabled = soldOut;
            b.setAttribute('data-soldout', soldOut ? 'true' : 'false');
            b.textContent = soldOut ? (dv + ' · epuizat') : dv;
            b.setAttribute('aria-pressed', dv === state.depth ? 'true' : 'false');
          });
        }
        if (depthIn) { depthIn.disabled = !legacy; depthIn.value = state.depth; }
        setText('[data-lnx-depth-label]', (real || legacy) ? state.depth : ((v && v.d) || state.depth));
      }

      // summer-promo member price — only for the models in the promo, and only while the
      // section says the window is open (Liquid computes D.promo.on, so this self-expires).
      var promoEl = $('[data-lnx-promo]');
      if (promoEl) {
        // Fara previzualizare prin `?lnx_promo=1`: ar fi aratat oricui o economie in afara oricarei
        // ferestre legale. Banda apare doar cand Liquid zice ca fereastra e deschisa.
        var promoOK = !!(D.promo && D.promo.on && (D.promo.models || []).indexOf(state.model) !== -1);
        promoEl.style.display = promoOK ? '' : 'none';
        // pct is withheld from the page for signed-out visitors (MAP: the reduction must not be
        // advertised, and a percentage in the JSON would let anyone derive it), so guard on it.
        if (promoOK && typeof D.promo.pct === 'number') {
          // Anchor on the floored price, the same basis the collection teaser and the cart nudge
          // use (their Liquid divides integer cents). Computing off the exact 4257.25 would make
          // the PDP say 3.832 while every other surface said 3.831.
          var pFull = Math.floor(price) * state.qty;
          var pMember = Math.round(pFull * (100 - D.promo.pct) / 100);
          setText('[data-lnx-promo-price]', money(pMember));
          setText('[data-lnx-promo-save]', money(pFull - pMember));
          // Keep the CURRENT variant in the href. Without `?variant=`, Shopify's /discount/
          // redirect lands on the bare product URL and the buy box falls back to the default
          // model (Omni Pro) — i.e. you'd click "Omni SE" and arrive at a different chair.
          var pTarget = '/products/' + D.promo.handle + (v ? '?variant=' + v.id : '');
          // Signed out → `/customer_authentication/login?return_to=` (relative only). The obvious
          // `/account/login?return_url=` silently DROPS the destination under new customer
          // accounts and dumps people on their account page, losing the chair they picked.
          promoEl.setAttribute('href', D.promo.loggedIn
            ? '/discount/' + D.promo.code + '?redirect=' + encodeURIComponent(pTarget)
            : '/customer_authentication/login?return_to=' + encodeURIComponent(pTarget));
        }
      }

      // bundle buttons — availability per model (hide packages with no variant) + price delta.
      // Baza ramane vizibila si cand e indisponibila (DENY + 0): altfel n-ar mai ramane niciun buton.
      $$('[data-lnx-bundle]').forEach(function (btn) {
        var b = btn.getAttribute('data-lnx-bundle');
        var isBase = !!(D.bundles && b === D.bundles[0]);
        btn.style.display = (bundleAvail(b) || (isBase && b === state.bundle && bundleExists(b))) ? '' : 'none';
        btn.setAttribute('aria-pressed', b === state.bundle ? 'true' : 'false');
        var add = btn.querySelector('[data-lnx-bundle-add]');
        var dlt = b === 'Bază' ? null : bundleDelta(b);
        var ieftin = dlt !== null && dlt < 0;
        if (add) {
          if (b === 'Bază') { add.textContent = t('included', 'inclus'); }
          // Exact, cu bani (+342,88), ca in Liquid: money() rotunjea in jos, sub diferenta reala.
          else { add.textContent = dlt === null ? '' : (ieftin ? moneyExact(-dlt) + ' ' + t('bundleLess', 'mai puțin') : '+' + moneyExact(dlt)); }
        }
        // Eticheta „Mai ieftin decât scaunul singur": doua preturi de azi, deci fara procent si fara pret taiat.
        btn.classList.toggle('lnx-bundle__opt--ieftin', ieftin);
        var tag = btn.querySelector('.lnx-bundle__tag');
        if (ieftin && !tag && btn.firstElementChild) {
          tag = document.createElement('span');
          tag.className = 'lnx-bundle__tag';
          tag.textContent = t('bundleCheaper', 'Mai ieftin decât scaunul singur');
          btn.firstElementChild.insertBefore(tag, btn.firstElementChild.firstChild);
        }
        if (tag) tag.style.display = ieftin ? '' : 'none';
      });
      // Semnul de sub pret: cat timp un pachet disponibil costa mai putin decat scaunul singur si nu e
      // ales deja, il aratam acolo unde se uita omul (pretul), cu ambele cifre. Clic = alege pachetul.
      var hint = $('[data-lnx-pachet-hint]');
      if (hint) {
        var hb = null, hp = 0, hs = modelBase(state.model);
        if (hasBundles()) (D.bundles || []).forEach(function (b) {
          if (b === 'Bază' || !bundleAvail(b)) return;
          var bv = bundleVar(b);
          if (bv && hs && bv.price < hs && (!hb || bv.price < hp)) { hb = b; hp = bv.price; }
        });
        var curD = state.bundle === 'Bază' ? null : bundleDelta(state.bundle);
        var hOn = !!hb && !(curD !== null && curD < 0);
        if (hOn) {
          hint.setAttribute('data-b', hb);
          hint.innerHTML = '<span>' + t('bundleHint', 'Cu suportul inclus: {p}, mai puțin decât scaunul singur ({s})').replace('{p}', '<b>' + moneyExact(hp) + '</b>').replace('{s}', moneyExact(hs)) + '</span><span class="lnx-pachet-hint__cta">' + t('bundleHintCta', 'Alege pachetul') + ' →</span>';
        }
        showEl(hint, hOn);
      }
      // temporary-discount highlight (e.g. Omni Pro)
      var tempEl = $('[data-lnx-tempdisc]');
      if (tempEl) tempEl.style.display = (D.tempDiscountModel && state.model === D.tempDiscountModel) ? '' : 'none';

      // compare cards
      $$('[data-lnx-cmp]').forEach(function (card) {
        var m = card.getAttribute('data-lnx-cmp');
        card.setAttribute('data-sel', m === state.model ? 'true' : 'false');
        var btn = card.querySelector('[data-lnx-cmp-btn]');
        if (btn) btn.textContent = (m === state.model) ? t('selected', 'Selectat ✓') : t('choose', 'Alege');
      });

      // Recenziile LiberNovo (B9): nota „exact acelasi scaun" nu se potriveste cu Omni Gen,
      // care e alt scaun; cand e selectat Gen apare nota generala.
      var isGen = state.model === 'Omni Gen';
      $$('[data-lnrev-same]').forEach(function (el) { el.hidden = isGen; });
      $$('[data-lnrev-gen]').forEach(function (el) { el.hidden = !isGen; });

      // Modulele pe model (docs/seo/module-pe-model-propunere.md): pe pagina Omni + Gen
      // (si pe pagina combinata) modelul se schimba fara re-randare, deci ce difera intre
      // modele se comuta aici. data-lnx-for="Omni Gen" sau "Omni|Omni Gen" (valori de
      // varianta, netraduse): elementul se vede doar cand modelul selectat e in lista.
      // Liquid randeaza deja starea pentru def_m (hidden style="display:none").
      $$('[data-lnx-for]').forEach(function (el) {
        var ok = ('|' + (el.getAttribute('data-lnx-for') || '') + '|').indexOf('|' + state.model + '|') !== -1;
        el.hidden = !ok;
        el.style.display = ok ? '' : 'none';
      });
      // Inclinarea: pe o pagina cu Omni sunt doua seturi de pastile (Omni are 4 pozitii, restul 5),
      // comutate mai sus. Pastila activa si eticheta se recalculeaza pe setul ramas vizibil.
      if (rSyncRef) rSyncRef();

      // titles / sticky (H1-ul e fix pe produs; data-lnx-model-title e subtitlul cu modelul)
      setText('[data-lnx-model-title]', state.model);
      setText('[data-lnx-sticky-title]', state.model);
      setText('[data-lnx-sticky-sub]', state.color + (hasBundles() ? ' · ' + bundleLabel(state.bundle) : ''));
      var sBig = $('[data-lnx-sticky-price]');
      if (sBig) sBig.innerHTML = moneyBig(price * state.qty); // same treatment as the headline
      var sOld = $('[data-lnx-sticky-old]');
      if (sOld) { sOld.textContent = campOK ? moneyExact(cmp * state.qty) : ''; showEl(sOld, campOK); }
      setText('[data-lnx-sticky-cta]', unavail ? t('unavailable', 'Indisponibil') : (pre ? t('preorderShort', 'Precomandă') : t('addShort', 'Adaugă')));
    }

    function bundleLabel(b) {
      // Cheile sunt valori de varianta si TREBUIE sa ramana in romana; doar etichetele se traduc.
      var map = T.bundleLabels || { 'Bază': 'Doar scaunul', '+ Stool': '+ Suport picioare', '+ Stool + Baterie': '+ Suport + acumulator', 'Standard': 'Pachet standard', 'Premium': 'Pachet premium' };
      return map[b] || b;
    }
    function setText(sel, txt) { var e = $(sel); if (e) e.textContent = txt; }

    function renderAll() { paint(); paintGallery(); }

    // Schimbarea modelului PE ACEEASI pagina (familia oprita, sau Omni <-> Omni Gen).
    function selectModel(m) {
      state.model = m;
      if (state.color === D.gatedColor && !glacierOK(state.model)) state.color = (D.colors && D.colors[0]) || 'Graphit';
      fixColor();
      fixDepth();
      if (!bundleAvail(state.bundle)) state.bundle = firstBundle(state.model);
      state.idx = 0;
      renderAll();
      syncUrl();
    }

    // ---- events: selectors ----
    // Un buton de model cu data-lnx-swap e al altei pagini: il preia lnx-familie.js (sau
    // navigarea normala). Pe un link de pe aceeasi pagina (data-lnx-same) pastram Cmd-clic.
    $$('[data-lnx-model]').forEach(function (btn) {
      on(btn, 'click', function (e) {
        if (btn.hasAttribute('data-lnx-swap')) return;
        if (btn.tagName === 'A' && !plainClick(e)) return;
        e.preventDefault();
        selectModel(btn.getAttribute('data-lnx-model'));
      });
    });
    $$('[data-lnx-color]').forEach(function (btn) {
      on(btn, 'click', function () {
        var c = btn.getAttribute('data-lnx-color');
        if (c === D.gatedColor && !glacierOK(state.model)) return;
        state.color = c;
        fixDepth();
        if (!bundleAvail(state.bundle)) state.bundle = firstBundle(state.model);
        state.idx = 0; renderAll(); syncUrl();
      });
    });
    $$('[data-lnx-depth]').forEach(function (btn) {
      on(btn, 'click', function () {
        if (btn.disabled) return;
        state.depth = btn.getAttribute('data-lnx-depth');
        if (realDepth(state.model)) {
          if (!bundleAvail(state.bundle)) state.bundle = firstBundle(state.model);
          paint(); syncUrl();
        } else {
          paint();
        }
      });
    });

    // Promo band, signed-in case: the label promises "Adaugă cu reducere", so actually do that —
    // add the selected variant, then hand off to /discount/ which applies the code and lands on
    // the cart. Plain navigation is the no-JS fallback (href is kept variant-accurate in paint()).
    var promoLink = $('[data-lnx-promo]');
    if (promoLink) {
      var promoBusy = false;
      on(promoLink, 'click', function (e) {
        if (!D.promo || !D.promo.loggedIn) return; // signed out → follow the login link
        var pv = variant();
        if (!pv) return;
        // Aceeasi garda ca la butoanele de cos: DENY + 0 nu se adauga (ar da 422).
        if (!pv.avail) { e.preventDefault(); return; }
        e.preventDefault();
        if (promoBusy) return;
        promoBusy = true;
        promoLink.setAttribute('aria-busy', 'true');
        var line = { id: pv.id, quantity: state.qty };
        // Proprietatea de adancime pleaca doar pe calea veche; cu variante reale e in varianta.
        if (legacyDepth()) {
          line.properties = { 'Adâncime șezut': state.depth };
        }
        var toCart = function () { location.href = '/discount/' + D.promo.code + '?redirect=/cart'; };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [line] }),
          credentials: 'same-origin'
        }).then(toCart, toCart);
      });
    }
    $$('[data-lnx-bundle]').forEach(function (btn) {
      on(btn, 'click', function () { state.bundle = btn.getAttribute('data-lnx-bundle'); paint(); syncUrl(); });
    });
    $$('[data-lnx-pachet-hint]').forEach(function (h) {
      on(h, 'click', function () {
        var b = h.getAttribute('data-b');
        if (!b) return;
        state.bundle = b; paint(); syncUrl();
        var sel = $('[data-lnx-bundle="' + b + '"]');
        if (sel && sel.scrollIntoView) {
          var calm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
          sel.scrollIntoView({ block: 'center', behavior: calm ? 'auto' : 'smooth' });
        }
      });
    });
    // Info „ce inseamna PRP" — click, nu hover: pe telefon hover-ul nu exista.
    var prpInfo = $('[data-lnx-prp-i]'), prpTip = $('[data-lnx-prp-tip]');
    if (prpInfo && prpTip) {
      on(prpInfo, 'click', function (e) {
        e.stopPropagation();
        var open = prpTip.hasAttribute('hidden');
        if (open) prpTip.removeAttribute('hidden'); else prpTip.setAttribute('hidden', '');
        prpInfo.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      on(document, 'click', function () {
        prpTip.setAttribute('hidden', ''); prpInfo.setAttribute('aria-expanded', 'false');
      });
      on(document, 'keydown', function (e) {
        if (e.key === 'Escape') { prpTip.setAttribute('hidden', ''); prpInfo.setAttribute('aria-expanded', 'false'); }
      });
    }

    var inc = $('[data-lnx-qty-inc]'); if (inc) on(inc, 'click', function () { state.qty = Math.min(state.qty + 1, 9); paint(); });
    var dec = $('[data-lnx-qty-dec]'); if (dec) on(dec, 'click', function () { state.qty = Math.max(state.qty - 1, 1); paint(); });

    // „Alege" din tabelul de comparatie: pe aceeasi pagina schimba modelul si urca la buy box.
    // Un link spre alta pagina (data-lnx-swap) il preia lnx-familie.js, altfel e navigare normala.
    $$('[data-lnx-cmp-btn]').forEach(function (btn) {
      on(btn, 'click', function (e) {
        if (btn.hasAttribute('data-lnx-swap')) return;
        if (btn.tagName === 'A' && !btn.hasAttribute('data-lnx-same')) return;
        if (btn.tagName === 'A' && !plainClick(e)) return;
        e.preventDefault();
        var card = btn.closest('[data-lnx-cmp]');
        if (card) selectModel(card.getAttribute('data-lnx-cmp'));
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });

    // ---- gallery nav ----
    var prev = $('[data-lnx-prev]'); if (prev) on(prev, 'click', function () { step(-1); });
    var next = $('[data-lnx-next]'); if (next) on(next, 'click', function () { step(1); });

    // ---- lightbox ----
    var lb = $('[data-lnx-lightbox]');
    var openLb = $('[data-lnx-open-lb]');
    if (openLb && lb) on(openLb, 'click', function () { lb.classList.remove('lnx-hidden'); paintGallery(); document.body.style.overflow = 'hidden'; });
    $$('[data-lnx-lb-close]').forEach(function (b) { on(b, 'click', function () { lb.classList.add('lnx-hidden'); document.body.style.overflow = ''; }); });
    var lbPrev = $('[data-lnx-lb-prev]'); if (lbPrev) on(lbPrev, 'click', function () { step(-1); });
    var lbNext = $('[data-lnx-lb-next]'); if (lbNext) on(lbNext, 'click', function () { step(1); });

    // ---- carousel scroll buttons ----
    var car = $('[data-lnx-car]');
    var cp = $('[data-lnx-car-prev]'); if (cp && car) on(cp, 'click', function () { car.scrollBy({ left: -Math.round(car.clientWidth * 0.8), behavior: 'smooth' }); });
    var cn = $('[data-lnx-car-next]'); if (cn && car) on(cn, 'click', function () { car.scrollBy({ left: Math.round(car.clientWidth * 0.8), behavior: 'smooth' }); });

    // ---- video modal ----
    var vm = $('[data-lnx-vmodal]');
    var vmVideo = vm ? vm.querySelector('video') : null;
    function openVideo(src, title, sub, note) {
      if (!vm) return;
      var canPlay = !!src && D.videoLive !== false;
      if (vmVideo) {
        if (canPlay) { vmVideo.src = src; vmVideo.style.display = ''; vmVideo.play().catch(function () {}); }
        else { vmVideo.removeAttribute('src'); vmVideo.style.display = 'none'; }
      }
      setVm('[data-lnx-vm-title]', title || '');
      setVm('[data-lnx-vm-sub]', sub || '');
      var noteEl = vm.querySelector('[data-lnx-vm-note]');
      if (noteEl) { noteEl.textContent = note || ''; noteEl.style.display = (note ? '' : 'none'); }
      var poster = vm.querySelector('[data-lnx-vm-poster]');
      if (poster) poster.style.display = canPlay ? 'none' : '';
      vm.classList.remove('lnx-hidden');
      document.body.style.overflow = 'hidden';
    }
    function setVm(sel, txt) { var e = vm && vm.querySelector(sel); if (e) e.textContent = txt; }
    function closeVideo() {
      if (!vm) return;
      if (vmVideo) { vmVideo.pause(); vmVideo.removeAttribute('src'); }
      vm.classList.add('lnx-hidden'); document.body.style.overflow = '';
    }
    $$('[data-lnx-play]').forEach(function (btn) {
      on(btn, 'click', function () {
        openVideo(btn.getAttribute('data-video') || '', btn.getAttribute('data-title') || '', btn.getAttribute('data-sub') || '', btn.getAttribute('data-note') || '');
      });
    });
    $$('[data-lnx-vm-close]').forEach(function (b) { on(b, 'click', closeVideo); });

    on(document, 'keydown', function (e) {
      if (e.key === 'Escape') {
        if (vm && !vm.classList.contains('lnx-hidden')) closeVideo();
        if (lb && !lb.classList.contains('lnx-hidden')) { lb.classList.add('lnx-hidden'); document.body.style.overflow = ''; }
      }
    });

    // ---- tabs: scrollspy + click ----
    var tabIds = D.tabIds || ['overview', 'features', 'specs', 'box', 'faq', 'reviews'];
    $$('[data-lnx-tab]').forEach(function (tb) {
      on(tb, 'click', function () {
        var id = tb.getAttribute('data-lnx-tab');
        var el = document.getElementById(id);
        if (el) { var y = el.getBoundingClientRect().top + window.scrollY - 104; window.scrollTo({ top: y, behavior: 'smooth' }); }
      });
    });

    // Pe telefon cele 6 taburi nu încap, deci bara e cu scroll orizontal. Fără
    // indiciu vizual nimeni nu-și dă seama. Arătăm un degrade la marginea unde
    // mai există conținut, și aducem tabul activ în vizor când se schimbă.
    var tabWrap = $('.lnx-tabnav__inner');
    var tabNav = tabWrap ? tabWrap.parentNode : null;
    var lastTab = null;
    function tabEdges() {
      if (!tabWrap || !tabNav) return;
      var max = tabWrap.scrollWidth - tabWrap.clientWidth;
      tabNav.setAttribute('data-more', tabWrap.scrollLeft < max - 2 ? 'true' : 'false');
      tabNav.setAttribute('data-back', tabWrap.scrollLeft > 2 ? 'true' : 'false');
    }
    function centerTab(tb) {
      if (!tabWrap || !tb) return;
      var max = tabWrap.scrollWidth - tabWrap.clientWidth;
      if (max <= 0) return;
      var target = tb.offsetLeft - (tabWrap.clientWidth - tb.offsetWidth) / 2;
      tabWrap.scrollLeft = Math.max(0, Math.min(target, max));
    }
    if (tabWrap) {
      on(tabWrap, 'scroll', tabEdges, { passive: true });
      on(window, 'resize', tabEdges, { passive: true });
      tabEdges();
    }

    // ---- sticky + scrollspy ----
    var ctaAnchor = $('[data-lnx-cta-anchor]');
    var sticky = $('[data-lnx-sticky]');
    function onScroll() {
      if (sticky && ctaAnchor) {
        var r = ctaAnchor.getBoundingClientRect();
        var vph = window.innerHeight || document.documentElement.clientHeight;
        // Keep a buy CTA always reachable (eMAG-style): show the sticky bar whenever the inline
        // Add-to-Cart is off-screen — scrolled above (bottom < 8) OR still below the fold (top > viewport).
        // On desktop the inline CTA sits above the fold, so the bar only appears after scrolling past it.
        sticky.setAttribute('data-show', (r.bottom < 8 || r.top > vph) ? 'true' : 'false');
      }
      var cur = null;
      tabIds.forEach(function (id) {
        var el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top < 160) cur = id;
      });
      $$('[data-lnx-tab]').forEach(function (tb) {
        tb.setAttribute('aria-current', tb.getAttribute('data-lnx-tab') === cur ? 'true' : 'false');
      });
      if (cur !== lastTab) {
        lastTab = cur;
        if (cur) centerTab($('[data-lnx-tab="' + cur + '"]'));
        timers.push(setTimeout(tabEdges, 240));
      }
    }
    on(window, 'scroll', onScroll, { passive: true });
    on(window, 'resize', onScroll, { passive: true });

    // ---- inline video autoplay on scroll (muted loop; only visible cards play; reduced-motion safe) ----
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autovids = $$('[data-lnx-autoplay]');
    if (autovids.length && 'IntersectionObserver' in window && !reduced) {
      vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var vv = en.target;
          if (en.isIntersecting && en.intersectionRatio >= 0.4) {
            if (vv.paused) { var pr = vv.play(); if (pr && pr.catch) pr.catch(function () {}); }
          } else if (!vv.paused) { vv.pause(); }
        });
      }, { threshold: [0, 0.4, 0.75] });
      autovids.forEach(function (vv) { vio.observe(vv); });
    }

    // ---- recline scroll-scrub module (sprite strip; frame-locked to scroll) ----
    var rRoot = $('[data-lnx-recline]');
    if (rRoot) {
      var rStrip = rRoot.querySelector('[data-lnx-recline-strip]');
      var rCap   = rRoot.querySelector('[data-lnx-recline-cap]');
      var rPills = Array.prototype.slice.call(rRoot.querySelectorAll('[data-lnx-recline-pill]'));
      var rStage = rRoot.querySelector('.lnx-recline__stage');
      var rPin   = rRoot.querySelector('.lnx-recline__pin');
      var rN     = parseInt(rRoot.getAttribute('data-frames'), 10) || 1;
      var R_TOP  = 84; // must match CSS .is-scrub .lnx-recline__pin top
      rMQ        = window.matchMedia('(min-width: 880px)');
      var rClamp = function (v, a, b) { return v < a ? a : (v > b ? b : v); };
      var rScrub = false;
      var rCur = 0;
      // Doar pastilele din setul vizibil: pe o pagina cu Omni, setul fiecarui model e intr-un
      // [data-lnx-for] comutat din paint(). Fara atributul asta (Maxis, SE, Pro) sunt toate.
      var rAct = function () {
        return rPills.filter(function (p) { var g = p.closest('[data-lnx-for]'); return !g || !g.hidden; });
      };

      var rSetFrac = function (frac) {
        frac = rClamp(frac, 0, 1);
        rCur = frac;
        if (rStrip && rN > 1) {
          var fi = Math.round(frac * (rN - 1));
          rStrip.style.backgroundPositionY = (fi / (rN - 1) * 100) + '%';
        }
        var best = null, bd = 9;
        rAct().forEach(function (p) {
          var d = Math.abs((parseFloat(p.getAttribute('data-frac')) || 0) - frac);
          if (d < bd) { bd = d; best = p; }
        });
        rPills.forEach(function (p) { p.setAttribute('aria-pressed', p === best ? 'true' : 'false'); });
        if (rCap && best) rCap.textContent = best.getAttribute('data-cap') || '';
      };

      var rProgress = function () {
        if (!rStage || !rPin) return 0;
        var rect = rStage.getBoundingClientRect();
        var total = rStage.offsetHeight - rPin.offsetHeight;
        return total > 0 ? rClamp(R_TOP - rect.top, 0, total) / total : 0;
      };

      var rOnScroll = function () {
        if (!rScrub) return;
        if (rRafRef.id) cancelAnimationFrame(rRafRef.id);
        rRafRef.id = requestAnimationFrame(function () { rRafRef.id = 0; rSetFrac(rProgress()); });
      };

      var rApplyMode = function () {
        rScrub = rMQ.matches && !reduced;
        rRoot.classList.toggle('is-scrub', rScrub);
        rSetFrac(rScrub ? rProgress() : 0);
      };
      rApplyModeRef = rApplyMode;
      // Fara scrub (telefon, reduced-motion): dupa Omni <-> Gen banda trebuie sa sara pe pastila
      // activa din setul ramas vizibil, nu sa ramana pe fractia unei pastile din setul ascuns.
      rSyncRef = function () {
        if (rScrub) { rSetFrac(rProgress()); return; }
        rSetFrac(rCur);
        var on = rAct().filter(function (p) { return p.getAttribute('aria-pressed') === 'true'; })[0];
        if (on) rSetFrac(parseFloat(on.getAttribute('data-frac')) || 0);
      };

      rPills.forEach(function (p) {
        on(p, 'click', function () {
          var frac = parseFloat(p.getAttribute('data-frac')) || 0;
          if (rScrub && rStage && rPin) {
            var rect = rStage.getBoundingClientRect();
            var total = rStage.offsetHeight - rPin.offsetHeight;
            window.scrollTo({ top: window.pageYOffset + (rect.top - R_TOP) + frac * total, behavior: 'smooth' });
          } else {
            rSetFrac(frac);
          }
        });
      });

      on(window, 'scroll', rOnScroll, { passive: true });
      on(window, 'resize', function () { rApplyMode(); rOnScroll(); }, { passive: true });
      if (rMQ.addEventListener) rMQ.addEventListener('change', rApplyMode);
      rApplyMode();
    }

    // ---- package slider (Componente / Asamblat) ----
    var pkg = $('[data-lnx-pkg]');
    if (pkg) {
      var pkgTrack = pkg.querySelector('[data-lnx-pkg-track]');
      var pkgTabs = $$('[data-lnx-pkg-tab]');
      var pkgDots = Array.prototype.slice.call(pkg.querySelectorAll('.lnx-pkg__dot'));
      var pkgN = pkgTrack.children.length;
      var pkgI = 0;
      var pkgGo = function (i) {
        pkgI = (i % pkgN + pkgN) % pkgN;
        pkgTrack.style.transform = 'translateX(' + (-pkgI * 100) + '%)';
        pkgTabs.forEach(function (tb, k) { tb.setAttribute('aria-pressed', k === pkgI ? 'true' : 'false'); });
        pkgDots.forEach(function (d, k) { d.setAttribute('data-sel', k === pkgI ? 'true' : 'false'); });
      };
      pkgTabs.forEach(function (tb) { on(tb, 'click', function () { pkgGo(parseInt(tb.getAttribute('data-lnx-pkg-tab'), 10)); }); });
      var pkgPrev = pkg.querySelector('[data-lnx-pkg-prev]'); if (pkgPrev) on(pkgPrev, 'click', function () { pkgGo(pkgI - 1); });
      var pkgNext = pkg.querySelector('[data-lnx-pkg-next]'); if (pkgNext) on(pkgNext, 'click', function () { pkgGo(pkgI + 1); });
      var pkgTX = null;
      on(pkg, 'touchstart', function (e) { pkgTX = e.touches[0].clientX; }, { passive: true });
      on(pkg, 'touchend', function (e) {
        if (pkgTX === null) return;
        var dx = e.changedTouches[0].clientX - pkgTX;
        if (Math.abs(dx) > 40) pkgGo(pkgI + (dx < 0 ? 1 : -1));
        pkgTX = null;
      }, { passive: true });
      var pkgMX = null;
      on(pkg, 'mousedown', function (e) { pkgMX = e.clientX; });
      on(window, 'mouseup', function (e) {
        if (pkgMX === null) return;
        var dx = e.clientX - pkgMX;
        if (Math.abs(dx) > 50) pkgGo(pkgI + (dx < 0 ? 1 : -1));
        pkgMX = null;
      });
    }

    // ---- starea de pornire: varianta randata pe server (D.selected) ----
    // Serverul a ales-o deja: ?variant= (fara NOU-), altfel prima Baza in stoc a modelului
    // implicit. Pornim exact de la ea, ca JS-ul sa nu suprascrie ce a randat Liquid.
    // Rezerva pentru un HTML vechi din cache, fara "selected": linkul ?variant= ca inainte,
    // apoi modelul implicit (ultimul vizibil).
    function fromVariant(pv) {
      if (!pv || !pv.o) return false;
      if (pv.o[0]) state.model = pv.o[0];
      if (pv.o[1]) state.color = pv.o[1];
      if (hasBundles() && pv.o[2]) state.bundle = pv.o[2];
      state.depth = pv.d || '48 cm';
      return true;
    }
    function byId(id) { return VARS.filter(function (v) { return String(v.id) === String(id); })[0]; }
    var started = false;
    if (D.selected) started = fromVariant(byId(D.selected));
    if (!started) {
      // ---- deep-link: preselect model/colour/package from ?variant= (Google Shopping / feed links land here) ----
      try {
        var _vid = new URLSearchParams(location.search).get('variant');
        if (_vid) started = fromVariant(byId(_vid));
      } catch (e) {}
    }
    if (!started) {
      if (D.models && D.models.length) state.model = D.models[D.models.length - 1];
      if (D.perModelColors) state.color = firstColorForModel(state.model);
    }

    renderAll();
    onScroll();
    analyticsCtx();

    // Tab lasat deschis peste ora de final: repictam la final, ca pretul taiat, procentul si
    // eticheta sa dispara fara reload. setTimeout nu duce peste ~24 de zile, deci pasi de
    // cel mult o ora, reprogramati pana se trece de final.
    (function campTimer() {
      if (!D.camp || !D.camp.on || !D.camp.end) return;
      var ms = D.camp.end * 1000 - Date.now();
      if (ms < 0) return;
      timers.push(setTimeout(function () { paint(); campTimer(); }, Math.min(ms + 1000, 3600000)));
    })();

    return destroy;
  }

  // Radacinile din el (sau el insusi, daca e o radacina).
  function roots(el) {
    if (!el) return Array.prototype.slice.call(document.querySelectorAll('[data-lnx-root]'));
    if (el.hasAttribute && el.hasAttribute('data-lnx-root')) return [el];
    return Array.prototype.slice.call(el.querySelectorAll ? el.querySelectorAll('[data-lnx-root]') : []);
  }
  function boot(el) { roots(el && el.nodeType ? el : null).forEach(init); }
  function destroy(el) { roots(el && el.nodeType ? el : null).forEach(function (r) { if (r.__lnxDestroy) r.__lnxDestroy(); }); }
  window.LNX = { boot: boot, destroy: destroy };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e && e.target && e.target.nodeType ? e.target : null); });
})();
